// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__B9tFx","row":"ProcedureTreatmentSummary_row__3tprj"};